import React, { useRef, useEffect, useState } from "react";
import Sidebar from "../common/Sidebar";
import { Editor } from "@tinymce/tinymce-react";
import "../customCss/Main.css";
import DataService from "../services/data.service";
import { ToastContainer, toast } from "react-toastify";
import Logout from "../common/Logout";

const AboutUs = () => {
  const editorRef = useRef(null);
  const editorRefTwo = useRef(null);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [sideTitle, setSideTitle] = useState("");
  const [bottomTitle, setBottomTitle] = useState("");
  const [aboutData, setAboutData] = useState([])
  const handleSubmit = (e) => {
    e.preventDefault();
    setMessage("");
    const data = {};
    if(aboutData){
      data.id = aboutData.id;
    }
    data.Heading = sideTitle;
    data.Description = editorRef.current.getContent();
    data.BottomHeading = bottomTitle;
    data.BottomDescription = editorRefTwo.current.getContent();
    DataService.addAboutUs(data).then(
      () => {
        toast.success("Data Added Successfully!")
        setTimeout(() => {
          window.location.reload();
        },2000)
      },
      (error) => {
        const resMessage =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          error.toString();
        setLoading(false);
        toast.error(resMessage, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    );
  };
  const getAboutData = async() => {
    await DataService.getAboutUs().then((data) => {
        const catData = data.data.data;
        setSideTitle(catData.Heading)
        setBottomTitle(catData.BottomHeading)
        setAboutData(catData);
    });
}
  useEffect(() => {
    document.title = "About Us";
    window.scrollTo(0, 0);
    getAboutData();
  }, []);
  return (
    <>
      <div className="main_section">
        <div className="main_flex">
          <div className="main_flexL">
            <Sidebar />
          </div>
          <div className="main_flexR">
            <div className="right_title">
              <h1>AboutUs</h1>
              <Logout/>
            </div>
            <div className="inter_inner">
              <div class="form-floating mb-3">
                <input
                  type="text"
                  class="form-control"
                  id="floatingInput"
                  placeholder=""
                  required
                  defaultValue={aboutData?.Heading}
                  value={sideTitle}
                  onChange={(e) => setSideTitle(e.target.value)}
                />
                <label for="floatingInput">Side Section Title</label>
              </div>
              <div className="form_field">
                <label>Side Section Description</label>
                <Editor
                  apiKey="1nolfd56snnawdzchbfmu06ihvzd2nkhvgvdj5i85do1bws6"
                  onInit={(evt, editor) => (editorRef.current = editor)}
                  initialValue={aboutData?.Description}
                  init={{
                    height: 500,
                    menubar: true,
                    plugins: [
                      "advlist",
                      "autolink",
                      "lists",
                      "link",
                      "image",
                      "charmap",
                      "preview",
                      "anchor",
                      "searchreplace",
                      "visualblocks",
                      "code",
                      "fullscreen",
                      "insertdatetime",
                      "media",
                      "table",
                      "code",
                      "help",
                      "wordcount",
                    ],
                    toolbar:
                      "undo redo | blocks | " +
                      "bold italic forecolor | alignleft aligncenter " +
                      "alignright alignjustify | bullist numlist outdent indent | " +
                      "removeformat | help",
                    content_style:
                      "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                  }}
                />
              </div>
              <div class="form-floating mb-3">
                <input
                  type="text"
                  class="form-control"
                  id="floatingInput"
                  placeholder=""
                  required
                  defaultValue={aboutData?.BottomHeading}
                  value={bottomTitle}
                  onChange={(e) => setBottomTitle(e.target.value)}
                />
                <label for="floatingInput">Bottom Section Title</label>
              </div>
              <div className="form_field">
                <label>Bottom Section Description</label>
                <Editor
                  apiKey="1nolfd56snnawdzchbfmu06ihvzd2nkhvgvdj5i85do1bws6"
                  onInit={(evt, editor) => (editorRefTwo.current = editor)}
                  initialValue={aboutData?.BottomDescription}
                  init={{
                    height: 500,
                    menubar: true,
                    plugins: [
                      "advlist",
                      "autolink",
                      "lists",
                      "link",
                      "image",
                      "charmap",
                      "preview",
                      "anchor",
                      "searchreplace",
                      "visualblocks",
                      "code",
                      "fullscreen",
                      "insertdatetime",
                      "media",
                      "table",
                      "code",
                      "help",
                      "wordcount",
                    ],
                    toolbar:
                      "undo redo | blocks | " +
                      "bold italic forecolor | alignleft aligncenter " +
                      "alignright alignjustify | bullist numlist outdent indent | " +
                      "removeformat | help",
                    content_style:
                      "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                  }}
                />
              </div>
              <div className="submit_sec">
                <button className="main_button" onClick={handleSubmit}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
